import { render } from "./ApplicationMGListAgComponent.vue?vue&type=template&id=64f8fd0c&scoped=true&ts=true"
import script from "./ApplicationMGListAgComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationMGListAgComponent.vue?vue&type=script&lang=ts"

import "./ApplicationMGListAgComponent.vue?vue&type=style&index=0&id=64f8fd0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f8fd0c"]])

export default __exports__